/* Generated by scripts/sync-proto-strings.mjs from design/prototype/js (the
   prototype's i18n tables). Do not edit: change the prototype or override
   the key in en.ts. The app is English only (2026-10-29). */
import type { Dict } from './core';

export const protoEn: Dict = {
  "a11y.col": "Navigation",
  "a11y.main": "Main",
  "act.settings": "Open settings",
  "act.theme.dark": "Use the Smoked (dark) theme",
  "act.theme.light": "Use the Pearl (light) theme",
  "c.back": "Back",
  "c.cancel": "Cancel",
  "c.close": "Close",
  "c.copied": "Copied",
  "c.done": "Done",
  "c.join": "Join",
  "c.members": {
    "one": "{n} member",
    "other": "{n} members"
  },
  "c.online": "{n} online",
  "c.save": "Save",
  "dock.deafen": "Deafen",
  "dock.mute": "Mute",
  "dock.settings": "User settings",
  "dock.undeafen": "Undeafen",
  "dock.unmute": "Unmute",
  "dock.you": "You",
  "hub.a11y.members": "Members",
  "hub.a11y.messages": "Messages in #{name}",
  "hub.a11y.servers": "Servers",
  "hub.a11y.tools": "Message actions",
  "hub.cat.toggle": "{name}, category",
  "hub.ch.mentions": {
    "one": "{n} mention",
    "other": "{n} mentions"
  },
  "hub.ch.settings": "Edit channel",
  "hub.ch.unread": "unread",
  "hub.chpop.title": "Channels",
  "hub.cmp.cancel": "Cancel reply",
  "hub.cmp.emoji": "Emoji",
  "hub.cmp.ph": "Message #{name}",
  "hub.cmp.send": "Send message",
  "hub.emoji.food": "Food & drink",
  "hub.emoji.frequent": "Frequently used",
  "hub.emoji.games": "Gaming",
  "hub.emoji.hearts": "Hearts & symbols",
  "hub.emoji.none": "No emoji match that",
  "hub.emoji.people": "Smileys & people",
  "hub.emoji.search": "Find the perfect emoji",
  "hub.h.hideMembers": "Hide member list",
  "hub.h.members": "Member list",
  "hub.h.pins": "Pinned messages",
  "hub.home": "Direct messages",
  "hub.img.open": "Open {name}",
  "hub.mem.offline": "Offline",
  "hub.mem.online": "Online",
  "hub.mem.owner": "Server owner",
  "hub.mention.everyone": "Notify everyone who can see this channel",
  "hub.mention.here": "Notify everyone online",
  "hub.mention.title": "Members",
  "hub.msg.bot": "BOT",
  "hub.msg.edited": "(edited)",
  "hub.msg.jump": "Jump to message",
  "hub.msg.more": "More",
  "hub.msg.pinnedTag": "Pinned",
  "hub.msg.react": "Add reaction",
  "hub.msg.reply": "Reply",
  "hub.official": "Official server",
  "hub.prof.about": "About me",
  "hub.prof.addFriend": "Add friend",
  "hub.prof.edit": "Edit profile",
  "hub.prof.message": "Message",
  "hub.prof.more": "More",
  "hub.prof.roles": "Roles",
  "hub.prof.since": "Member since",
  "hub.react.add": "Add reaction",
  "hub.spoiler": "Spoiler, click to reveal",
  "hub.srv.menu": "Server menu",
  "hub.start.sub": "This is the start of the #{name} channel.",
  "hub.start.title": "Welcome to #{name}!",
  "hub.vc.fullTip": "This channel is full ({n} of {max})",
  "hubv.dm.create": "Create DM",
  "hubv.dm.friends": "Friends",
  "hubv.dm.members": {
    "one": "{n} member",
    "other": "{n} members"
  },
  "hubv.dm.title": "Direct messages",
  "hubv.fr.accept": "Accept",
  "hubv.fr.accepted": "You and {name} are now friends",
  "hubv.fr.add": "Add friend",
  "hubv.fr.addTitle": "Add friend",
  "hubv.fr.all": "All",
  "hubv.fr.blocked": "Blocked",
  "hubv.fr.blockedNone": "You haven't blocked anyone.",
  "hubv.fr.group": "{label} — {n}",
  "hubv.fr.ignore": "Ignore",
  "hubv.fr.incoming": "Incoming friend request",
  "hubv.fr.message": "Message",
  "hubv.fr.more": "More",
  "hubv.fr.none": "No one matches “{q}”",
  "hubv.fr.online": "Online",
  "hubv.fr.pending": "Pending",
  "hubv.fr.pendingNone": "No pending requests.",
  "hubv.fr.remove": "Remove friend",
  "hubv.fr.removed": "Removed {name} from friends",
  "hubv.fr.search": "Search",
  "hubv.fr.send": "Send friend request",
  "hubv.fr.sent": "Your friend request to {name} was sent.",
  "hubv.vr.chat": "Show chat",
  "hubv.vr.connected": "Voice connected",
  "hubv.vr.connecting": "Connecting…",
  "hubv.vr.connectingTo": "Connecting to {name}…",
  "hubv.vr.controls": "Voice controls",
  "hubv.vr.empty": "No one is here yet",
  "hubv.vr.hideChat": "Hide chat",
  "hubv.vr.inside": {
    "one": "{n} person inside",
    "other": "{n} people inside"
  },
  "hubv.vr.join": "Join voice",
  "hubv.vr.kbps": "{n} kbps",
  "hubv.vr.leave": "Disconnect",
  "hubv.vr.measuring": "measuring",
  "hubv.vr.more": "More options",
  "hubv.vr.mute": "Mute",
  "hubv.vr.notIn": "You're not in {name}",
  "hubv.vr.pttMuted": "You're muted",
  "hubv.vr.pttTalking": "Talking",
  "hubv.vr.unmute": "Unmute",
  "hubv.vr.va": "Voice activity",
  "pal.actions": "Actions",
  "pal.channels": "Channels",
  "pal.empty": "Nothing matches “{q}”",
  "pal.hint.close": "to close",
  "pal.hint.move": "to move",
  "pal.hint.open": "to open",
  "pal.people": "People",
  "pres.copy": "Copy username",
  "pres.custom": "Set a custom status",
  "pres.dnd": "Do not disturb",
  "pres.dnd.sub": "You won't get desktop notifications",
  "pres.idle": "Idle",
  "pres.invisible": "Invisible",
  "pres.invisible.sub": "You'll appear offline, but have full access",
  "pres.offline": "Offline",
  "pres.online": "Online",
  "pres.profile": "View profile",
  "set.about": "About",
  "set.about.version": "Version {v}",
  "set.app": "App settings",
  "set.appearance": "Appearance",
  "set.close": "Close settings",
  "set.esc": "ESC",
  "set.theme": "Theme",
  "set.theme.dark": "Smoked",
  "set.theme.light": "Pearl",
  "set.theme.sub": "Pearl follows the light, Smoked the dark. System matches Windows.",
  "set.theme.system": "System",
  "set.title": "Settings",
  "set.user": "User settings",
  "tb.search": "Search or jump to…",
  "voice.connected": "Voice connected",
  "voice.connecting": "Connecting…",
  "voice.leave": "Disconnect",
  "voice.measuring": "measuring"
};
